import * as React from 'react';
import LeaveTypes from '../../../components/LeaveTypes';
import './Notifications.scss';
import { format, differenceInSeconds,differenceInHours,differenceInMinutes  } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { NotificationI } from '../../../types';
import { requestDetailsModalCall } from '../../../containers/MainWrapper/MainWrapper';
import { LeaveTypesStore } from '../../../store/LeaveTypesList';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

interface NotificationGeneralPropsI {
  message: NotificationI,
  deleteNotif: (msgId: number) => void,
  onClose: () => void,
  isCreated: boolean,
}

export const NotificationGeneral = observer((props: NotificationGeneralPropsI) => {
  const {t} = useTranslation();
  const {message, onClose , deleteNotif} = props;
  const timeInstance = (date?: string) => date? new Date(date) : new Date() ;
  const isStringFormat = (time: string) =>  differenceInHours(timeInstance(), timeInstance(time)) < 24 ;

  const {leaveTypesById, getLeaveTypesByRequestId} = LeaveTypesStore;


  useEffect(()=> {
    getLeaveTypesByRequestId(message.leaveRequestId);
  },[props.message]);

  const formatStringRange = (time: string) => {
    const diffHours = differenceInHours(new Date(), new Date(time));
    const diffMinutes = differenceInMinutes(new Date(), new Date(time));
    const diffSeconds = differenceInSeconds(new Date(), new Date(time));
    if(diffHours){
      return `${diffHours} h`;
    } else if (diffMinutes) {
      return `${diffMinutes} min`;
    } else {
      return `${diffSeconds} sec`;
    }
  };
  const toFixStatus = (status: string) =>{
    return status.charAt(0).toUpperCase() + status.toLocaleLowerCase().slice(1);
  };
  const getStatusClassName = (status: string) => {
    switch(status.toUpperCase()) {
    case 'APPROVED':
      return 'notification__title__status notification__title__status_approved';
    case 'REJECTED':
      return 'notification__title__status notification__title__status_rejected';
      break;
    default:
      return 'notification__title__status';
    }
  };
  return <>
    <div className={'notification__title'}>
      <span className={'notification__title__text'}>{t('leaveRequest')}</span>
      <div className={`${getStatusClassName(message.status)}`} onClick={()=>{
        onClose();
        deleteNotif(message.id);
        requestDetailsModalCall.show({id: message.leaveRequestId });
      }}>{!props.isCreated ? toFixStatus(message.status) : 'View details'}</div>
    </div>
    <div className={'notification_general'}>
      <div className={'notification__content'}>
        {props.isCreated && <div className={'notification__content__item'}>
          <span className={'itemLeft'}>
            {t('notifications_title_createdBy')}:
          </span>
          <div className={'itemRight'}>
            {message.authorName}
          </div>
        </div>}
        <div className={'notification__content__item'}>
          <span className={'itemLeft'}>
            {t('notifications_title_dates')}:
          </span>
          <div className={'itemRight'}>
            {format(new Date(message.startDate), 'dd.MM.yyyy')}-{format(new Date(message.endDate), 'dd.MM.yyyy')}
          </div>
        </div>
        <div className={'notification__content__item'}>
          <span className={'itemLeft'}>
            {t('notifications_title_reason')}:
          </span>
          <div className={'itemRight'}>
            <LeaveTypes leaveTypes={leaveTypesById} type={message.type}  infoMessageVisible/>
          </div>
        </div>
      </div>
      <div className={'creationDate'}>
        {isStringFormat(message.messageTime)
          ?
          <span>{formatStringRange(message.messageTime)} {t('notifications_ago')}</span>
          :
          format(timeInstance(message.messageTime), 'dd.MM.yyyy HH:mm') }
      </div>
    </div>
  </>;
});
